// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"556":"c1281c59","895":"c5b16c7f"}[chunkId] + ".css";
};